import React from 'react';

import AppModal from 'components/modal/appModal';
import { SimpleModalId } from 'constants/modalId';
import { ClientsUserPasswordModalBodyContainer } from './password-modal-body/password-modal-body.container';

export const ClientsUserPasswordModal = () => {
  return (
    <AppModal id={SimpleModalId.ClientsUserSuccessMessage} title="New user password" hideOpenButton>
      <ClientsUserPasswordModalBodyContainer />
    </AppModal>
  );
};
